<template>
  <div v-if="tag.tag" class="price-tag" :style="wrapperStyle">
    <div class="tag-text" :style="priceStyle">{{ tag.tag }}</div>
    <div class="arrow" :style="priceStyle"></div>
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      default: () => ({})
    },
    tagStyle: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    priceStyle() {
      return {
        color: this.tag.textColor,
        backgroundColor: this.tag.backgroundColor,
        fontSize: this.tag.textSize ? `${this.tag.textSize}px` : '11px'
      }
    },
    wrapperStyle() {
      return {
        color: this.tag.textColor,
        backgroundColor: this.tag.backgroundColor,
        fontSize: this.tag.textSize ? `${this.tag.textSize}px` : '11px',
        ...this.tagStyle
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.price-tag {
  position: relative;

  max-width: 100%;
  width: max-content;
  height: 16px;

  border-radius: 0.08rem;
  .tag-text {
    display: inline-block;

    max-width: 100%;
    width: max-content;
    height: 16px;

    padding: 0 0.12rem;
    border-radius: 0.08rem;

    line-height: 16px;

    @include text-overflow-ellipsis-single;
  }
  .arrow {
    display: block;

    position: absolute;
    bottom: -6px;
    left: 8px;

    border: 3px solid #fff;
    // border-top: 7px solid #fff;
    border-top: 3px solid transparent;
  }
}
</style>
